"use strict";

exports.__esModule = true;
var _RoleListLoader = require("./RoleListLoader");
Object.keys(_RoleListLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleListLoader[key]) return;
  exports[key] = _RoleListLoader[key];
});
var _RoleListContext = require("./RoleListContext");
Object.keys(_RoleListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleListContext[key]) return;
  exports[key] = _RoleListContext[key];
});